import React from 'react';
import { MailIcon, PhoneIcon, MapPinIcon, ClockIcon } from 'lucide-react';
export function Contact() {
  return <div className="min-h-screen bg-gradient-to-b from-white to-slate-50" data-id="element-199">
      <section className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-16" data-id="element-200">
        <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4 text-center" data-id="element-201">
          Contact Us
        </h1>
        <p className="text-xl text-slate-600 text-center mb-12" data-id="element-202">
          Our team replies within one working day
        </p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12" data-id="element-203">
          {/* Contact Information */}
          <div className="bg-white rounded-2xl shadow-lg p-8" data-id="element-204">
            <h2 className="text-2xl font-bold text-slate-900 mb-6" data-id="element-205">
              Get in Touch
            </h2>
            <p className="text-slate-600 mb-8 leading-relaxed" data-id="element-206">
              Whether you have a question about our service, pricing, or
              anything else, our team is ready to answer all your questions.
            </p>

            <div className="space-y-6" data-id="element-207">
              <div className="flex items-start gap-4" data-id="element-208">
                <div className="w-12 h-12 bg-emerald-100 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-209">
                  <MailIcon className="w-6 h-6 text-emerald-600" data-id="element-210" />
                </div>
                <div data-id="element-211">
                  <p className="font-semibold text-slate-900 mb-1" data-id="element-212">Email</p>
                  <a href="mailto:hubtut84@gmail.com" className="text-emerald-600 hover:text-emerald-700 transition-colors" data-id="element-213">
                    hubtut84@gmail.com
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-214">
                <div className="w-12 h-12 bg-emerald-100 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-215">
                  <PhoneIcon className="w-6 h-6 text-emerald-600" data-id="element-216" />
                </div>
                <div data-id="element-217">
                  <p className="font-semibold text-slate-900 mb-1" data-id="element-218">Phone</p>
                  <p className="text-slate-600" data-id="element-219">To be confirmed</p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-220">
                <div className="w-12 h-12 bg-emerald-100 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-221">
                  <MapPinIcon className="w-6 h-6 text-emerald-600" data-id="element-222" />
                </div>
                <div data-id="element-223">
                  <p className="font-semibold text-slate-900 mb-1" data-id="element-224">Address</p>
                  <p className="text-slate-600" data-id="element-225">To be confirmed</p>
                </div>
              </div>

              <div className="flex items-start gap-4" data-id="element-226">
                <div className="w-12 h-12 bg-emerald-100 rounded-lg flex items-center justify-center flex-shrink-0" data-id="element-227">
                  <ClockIcon className="w-6 h-6 text-emerald-600" data-id="element-228" />
                </div>
                <div data-id="element-229">
                  <p className="font-semibold text-slate-900 mb-1" data-id="element-230">
                    Support Hours
                  </p>
                  <p className="text-slate-600" data-id="element-231">
                    Monday - Friday: 9:00 AM - 5:00 PM
                  </p>
                  <p className="text-slate-600" data-id="element-232">Saturday - Sunday: Closed</p>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Form */}
          <div className="bg-white rounded-2xl shadow-lg p-8" data-id="element-233">
            <h2 className="text-2xl font-bold text-slate-900 mb-6" data-id="element-234">
              Send Us a Message
            </h2>

            <form className="space-y-6" data-id="element-235">
              <div data-id="element-236">
                <label htmlFor="name" className="block text-sm font-semibold text-slate-900 mb-2" data-id="element-237">
                  Full Name
                </label>
                <input type="text" id="name" className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 outline-none transition-all" placeholder="Your name" data-id="element-238" />
              </div>

              <div data-id="element-239">
                <label htmlFor="email" className="block text-sm font-semibold text-slate-900 mb-2" data-id="element-240">
                  Email Address
                </label>
                <input type="email" id="email" className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 outline-none transition-all" placeholder="your@email.com" data-id="element-241" />
              </div>

              <div data-id="element-242">
                <label htmlFor="subject" className="block text-sm font-semibold text-slate-900 mb-2" data-id="element-243">
                  Subject
                </label>
                <input type="text" id="subject" className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 outline-none transition-all" placeholder="How can we help?" data-id="element-244" />
              </div>

              <div data-id="element-245">
                <label htmlFor="message" className="block text-sm font-semibold text-slate-900 mb-2" data-id="element-246">
                  Message
                </label>
                <textarea id="message" rows={5} className="w-full px-4 py-3 border border-slate-300 rounded-lg focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 outline-none transition-all resize-none" placeholder="Tell us more about your enquiry..." data-id="element-247"></textarea>
              </div>

              <button type="submit" className="w-full px-6 py-3 bg-emerald-500 text-white font-semibold rounded-lg hover:bg-emerald-600 transition-colors shadow-sm hover:shadow-md" data-id="element-248">
                Send Message
              </button>
            </form>
          </div>
        </div>

        {/* Response Time Notice */}
        <div className="bg-emerald-50 border border-emerald-200 rounded-xl p-6 text-center" data-id="element-249">
          <p className="text-slate-700" data-id="element-250">
            <span className="font-semibold text-emerald-700" data-id="element-251">
              Quick Response Guarantee:
            </span>{' '}
            Our team replies to all enquiries within one working day during
            business hours.
          </p>
        </div>
      </section>
    </div>;
}